import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import CSSModules from 'react-css-modules';
import Button from 'toluna-react-components/Inputs/Button';
import {find as lodashFind} from 'lodash';
import styles from './styles.scss';

class RangeFilter extends Component {
  constructor(props) {
	super(props);

	this.name = 'RangeFilter';

	const {title, from = 0, to = 0, min = 0, max = 0, applyStr, cancelStr, clearStr, fromStr, toStr} = this.props.filterData;

	this.closeFilter = this.closeFilter.bind(this);
	this.onFilterApply = this.onFilterApply.bind(this);
	this.getMainBlock = this.getMainBlock.bind(this);
	this.getButtonsBlock = this.getButtonsBlock.bind(this);
	this.clearValues = this.clearValues.bind(this);
	this.onValueChange = this.onValueChange.bind(this);

	this.canApply = this.canApply.bind(this);

	this.state = {
	  title,
	  from,
	  to,
	  min,
	  max,
	  applyStr,
	  cancelStr,
	  clearStr,
	  fromStr,
	  toStr
	};
  }

  componentDidMount() {
	this.fromInput.focus();
  }

  render() {
	//console.log(this.state, this.canApply());
	return (
		<div styleName="range-filter">
		  <div styleName="title">
			<span>{this.state.title || 'Range filter'}</span>
			{/* <span styleName="clear-button" onClick={this.clearValues}>CLEAR</span>*/}
			<Button styleName="clear-button" onClick={this.clearValues}
					buttonStyle={Button.BUTTON_STYLE.CENTERED_CONTENT} text={this.state.clearStr || "CLEAR"} small/>
		  </div>
		  {this.getMainBlock()}
		  <hr/>
		  {this.getButtonsBlock()}
		</div>
	);
  }

  closeFilter() {
	this.props.closeFilter();
  }


  clearValues(evt) {
	this.setState({
	  from: this.state.min,
	  to: this.state.max
	})
  }

  onValueChange(evt) {
	let {name, value} = evt.target;
	if (parseFloat(value) < 0) {
	  return false;
	}
	const {min, max} = this.state;
	this.setState({
	  [name]: parseFloat(value)
	})
  }

  canApply() {
	const {from, to, min, max} = this.state;

	if (from < min || to > max || from > to) {
	  return false;
	}

	if (isNaN(from) || isNaN(to)) {
	  return false;
	}

	return true;
  }

  getMainBlock() {
	return (
		<div styleName="main-block">
		  <div styleName="content">
			<div styleName="from-block">
			  <span>{this.state.fromStr || 'From'}</span>
			  <input ref={(element) => {
				this.fromInput = element;
			  }} type="number" name="from" value={this.state.from} onChange={this.onValueChange}/>
			</div>
			<div styleName="to-block">
			  <span>{this.state.toStr || 'To'}</span>
			  <input ref={(element) => {
				this.toInput = element;
			  }} type="number" name="to" value={this.state.to} onChange={this.onValueChange}/>
			</div>
		  </div>
		</div>
	);
  }

  getButtonsBlock() {
	const canApply = this.canApply();
	return (
		<div styleName="buttons-block">
		  <Button
			  styleName="btnCancel"
			  onClick={this.closeFilter}
			  buttonStyle={Button.BUTTON_STYLE.CENTERED_CONTENT}
			  text={this.state.cancelStr || "Cancel"}
			  small
		  />
		  <Button
			  styleName="btnApply"
			  onClick={this.onFilterApply}
			  buttonStyle={Button.BUTTON_STYLE.RECTANGLE}
			  text={this.state.applyStr || "Apply"}
			  small
			  primary
			  disabled={!canApply}
		  />
		</div>
	);
  }


  onFilterApply(evt) {
	const {from, to} = this.state;

	this.props.applyFilter({
	  items: {
		from,
		to
	  }
	});
  }
}

export default CSSModules(RangeFilter, {...styles}, {allowMultiple: true});


RangeFilter.propTypes = {
  applyFilter: PropTypes.func.isRequired,
  closeFilter: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./components/qual/Table/TableHeader/TableHeaderCell/TableColumnFilter/FilterTypes/Range/RangeFilter_component.js